


















import { Component, Prop, Vue } from 'vue-property-decorator';

import { DbUtile } from "../database/DbUtile";
import { DbUser } from '../database/DbUser';

@Component
export default class AttendanceProfile extends Vue {
  @Prop() user?: DbUser | null;
}
